export const ATS_PRE_APPLICATIONS_TOUR = 'ats_pre_applications';
export const ATS_POST_APPLICATIONS_TOUR = 'ats_post_applications';

export const atsJobActionsWalkthroughSteps = [
  {
    id: 'invited-tab',
    target: '[data-walkthrough="ats-invited-tab"]',
    title: 'How hiring on Twine works',
    body:
      'Start here to browse freelancers and invite experts to apply to your job.',
    placement: 'bottom',
  },
  {
    id: 'applied-tab',
    target: '[data-walkthrough="ats-applied-tab"]',
    title: 'Applied Tab',
    body:
      'New applications appear here so you can review experts and move them through your pipeline.',
    placement: 'bottom',
  },
  {
    id: 'workflow-tabs',
    target: '[data-walkthrough="ats-workflow-tab"]',
    title: 'Hiring Workflow',
    body:
      'Use these tabs to organize candidates as you review, shortlist, or decline them.',
    placement: 'bottom',
    multiTarget: true,
  },
  {
    id: 'hired-tab',
    target: '[data-walkthrough="ats-hired-tab"]',
    title: 'Hired Tab',
    body:
      'Hired experts stay here so you can manage payments and ongoing work.',
    placement: 'bottom',
  },
  {
    id: 'job-actions',
    target: '[data-walkthrough="ats-job-actions"]',
    title: 'Job Management Actions',
    body:
      'Use these cards to manage your job, boost visibility, review questions, and enable AI Recruiter.',
    placement: 'bottom',
  },
  {
    id: 'job-menu',
    target: '[data-walkthrough="ats-job-menu"]',
    title: 'Job Settings Menu',
    body:
      'Open this menu to edit, duplicate, or change visibility settings.',
    placement: 'left',
  },
];

export const atsApplicationReviewWalkthroughSteps = [
  {
    id: 'applicant-card',
    target: '[data-walkthrough="applicant-card"]',
    title: 'Welcome to Application Review',
    body:
      'Start here to open an application and review the expert in the detail panel.',
    placement: 'right',
  },
  {
    id: 'application-tab',
    target: '[data-walkthrough="detail-tab-application"]',
    title: 'Application Tab',
    body:
      "Review the expert's pitch, key qualifications, and CV if they included one.",
    placement: 'bottom',
  },
  {
    id: 'messages-tab',
    target: '[data-walkthrough="detail-tab-messages"]',
    title: 'Messages Tab',
    body:
      'Message the expert to ask questions, discuss details, or schedule interviews.',
    placement: 'bottom',
  },
  {
    id: 'portfolio-tab',
    target: '[data-walkthrough="detail-tab-portfolio"]',
    title: 'Portfolio Tab',
    body:
      "Browse the expert's Twine portfolio to assess their style and experience.",
    placement: 'bottom',
  },
  {
    id: 'notes-tab',
    target: '[data-walkthrough="detail-tab-notes"]',
    title: 'Internal Notes',
    body:
      'Add private team notes to track feedback and interview impressions.',
    placement: 'bottom',
  },
  {
    id: 'payments-tab',
    target: '[data-walkthrough="detail-tab-payments-placeholder"]',
    title: 'Payments Tab',
    body:
      'After hiring, a Payments tab will appear here for managing vaulted funds, bills, and one-off payments.',
    placement: 'bottom',
  },
];
